module.exports = __webpack_public_path__ + "img/bg_play_default.cbf83664.png";